export const SHOW_WORK_SHIFT_DETAIL_EVENT = "show-work-shift-detail-event";
